import HourglassSpinner from "./HourglassSpinner";

export default HourglassSpinner;
